import clsx from "clsx"

export const renderAttribute = (attribute: {
    title: {
        value: string,
        className?: string
    },
    value: {
        value: string[],
        className?: string
        component?: React.ReactNode
    }
}, container?: {
    className: string
}) => {
    return (
        <div className={clsx('flex items-center gap-2', container?.className)}>
            <p className={clsx('font-light', attribute.title.className)}>{attribute.title.value}</p>
            {attribute.value.component ? attribute.value.component : (
                <p className={clsx('font-normal first-letter:uppercase', attribute.value.className)}>
                    {attribute.value.value[0] + (attribute.value.value.length > 1 ? ` et al` : '')}
                </p>
            )}
        </div>
    )
}